var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCadConversion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2621_10140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 31,
    fill: "#00C67F",
    fillOpacity: 0.11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2621_10140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6448 49.0893L47.6549 49.0424C47.8491 48.2422 48.0935 47.2444 47.9026 46.3404C47.7754 45.6272 47.2497 45.3493 46.8011 45.3292C46.272 45.3058 45.7999 45.6071 45.6828 46.0458C45.4618 46.8493 45.6593 47.9475 46.0209 49.3471C45.5656 50.4319 44.839 52.0089 44.3066 52.9464C43.3156 53.4587 41.9863 54.2489 41.7888 55.2467C41.7486 55.4308 41.7955 55.6652 41.906 55.8761C42.0299 56.1105 42.2274 56.2913 42.4584 56.3783C42.5589 56.4152 42.6794 56.4453 42.82 56.4453C43.4093 56.4453 44.3636 55.9699 45.6359 53.7868C45.8301 53.7232 46.031 53.6562 46.2252 53.5893C47.1359 53.2812 48.0801 52.9598 48.9339 52.8158C49.8781 53.3214 50.9528 53.6462 51.6828 53.6462C52.406 53.6462 52.6906 53.2176 52.7977 52.9598C52.9852 52.5078 52.8948 51.9386 52.5901 51.6339C52.1482 51.1987 51.0734 51.0848 49.3993 51.2924C48.5756 50.7902 48.0366 50.1071 47.6448 49.0893ZM43.9718 54.1752C43.5064 54.8516 43.1549 55.1897 42.964 55.3371C43.1883 54.9252 43.627 54.49 43.9718 54.1752ZM46.9049 46.2902C47.079 46.5882 47.0555 47.4888 46.9216 47.9442C46.7575 47.2779 46.7341 46.3337 46.8312 46.2232C46.858 46.2266 46.8814 46.2467 46.9049 46.2902ZM46.8513 50.3248C47.2095 50.9442 47.6616 51.4766 48.1604 51.8717C47.4372 52.0357 46.7776 52.3069 46.1883 52.548C46.0477 52.6049 45.9104 52.6618 45.7765 52.7154C46.2218 51.9085 46.5935 50.9944 46.8513 50.3248ZM52.0611 52.5179C52.0645 52.5246 52.0678 52.5346 52.0477 52.548H52.041L52.0343 52.558C52.0075 52.5748 51.733 52.7355 50.5511 52.2701C51.9104 52.2065 52.0578 52.5145 52.0611 52.5179ZM58.4696 39.5201L51.2642 32.3147C51.0633 32.1138 50.7921 32 50.5075 32H36.2843C35.6917 32 35.2129 32.4788 35.2129 33.0714V60.9286C35.2129 61.5212 35.6917 62 36.2843 62H57.7129C58.3055 62 58.7843 61.5212 58.7843 60.9286V40.2801C58.7843 39.9955 58.6705 39.721 58.4696 39.5201ZM56.3133 40.7723H50.012V34.471L56.3133 40.7723ZM56.3736 59.5893H37.6236V34.4107H47.7352V41.6429C47.7352 42.0158 47.8834 42.3735 48.1471 42.6372C48.4108 42.9009 48.7685 43.0491 49.1415 43.0491H56.3736V59.5893Z",
    fill: "#20435D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2621_10140",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_2621_10140"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2621_10140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(32 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadConversion);
export default __webpack_public_path__ + "static/media/cad-conversion.291ab07609693b06662dabd6fa4a9dae.svg";
export { ForwardRef as ReactComponent };